import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CommonDonations from "../devotee/donation/commonDonations";
import Paper, { PaperProps } from "@mui/material/Paper";
import Draggable from "react-draggable";
import { useNavigate } from "react-router-dom";
import { RoutingURLs } from "../common/RoutingURLs";

interface DonationPopupProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function PaperComponent(props: PaperProps) {
  const [bounds, setBounds] = useState({ top: 0, left: 0, right: 0, bottom: 0 });

  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
      bounds="parent"
      onDrag={(e: any, data) => {
        const parentElement = e.target instanceof HTMLElement ? e.target.parentElement : null;
        if (!parentElement) return;

        const parentBounds = parentElement.getBoundingClientRect();
        const dialogBounds = e.target.getBoundingClientRect();

        const newBounds = {
          top: parentBounds.top - dialogBounds.top,
          left: parentBounds.left - dialogBounds.left,
          right: parentBounds.right - dialogBounds.right + window.innerWidth - dialogBounds.width,
          bottom: parentBounds.bottom - dialogBounds.bottom + window.innerHeight - dialogBounds.height
        };

        setBounds(newBounds);
      }}
    >
      <Paper {...props} style={{ ...props.style, ...{ position: 'relative' } }} />
    </Draggable>
  );
}


const CommonDonationPopup = (props: DonationPopupProps) => {
  const navigate = useNavigate();
  
  const handleClose = (): void => {
    navigate(RoutingURLs.home)
    props.setIsOpen(false);
  };

  return (
    <div >
      <Dialog
        open={props.isOpen}
        aria-describedby="alert-dialog-description"
        maxWidth="xl"
        PaperProps={{
          style: {
            width:"700px",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
            maxWidth: "1148px",
            maxHeight: "755px",
          },
        }}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <div
          style={{
            backgroundColor: "#882E14",
            height: "46px",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          }}
        >
          <DialogTitle
            sx={{ fontWeight: 700, fontSize: "28px", color: "white",cursor:"move", padding: "0px 24px" }}
          >
            {"Donation"}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 24,
              top: 2,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </div>
        <DialogContent sx={{ padding: 0 }}>
          {" "}
          <CommonDonations setIsOpen={props.setIsOpen}/>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default CommonDonationPopup;
